export const GET_ALL_TEMPLATES="GET_ALL_TEMPLATES";
export const IMPORT_TEMPLATE="IMPORT_TEMPLATE"
export const SET_TEMPLATE="SET_TEMPLATE"
export const EDIT_TEMPLATE="EDIT_TEMPLATE"
export const SET_CURRENT_ACTION = "SET_CURRENT_ACTION"
export const GET_TEMPLATE = "GET_TEMPLATE";
export const SET_TEMPLATE_DATA = "SET_TEMPLATE_DATA";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE"
export const LOADING ="LOADING"